<template>
  <div>
    <FITWorkflowProgressbar class="mb-0 pb-0" ref="GIWorkflowProgress" :startingIndex="workflowCurrentIndex" :steps="workflow">
    </FITWorkflowProgressbar>
    <FITModal ref="newGiModal" :noFooter="true" reference="newGiModal" :title="$t('general.notification')">
      <div slot="body">
        <div class="my-4">
          <h5 v-html="notificationContent"></h5>
        </div>
        <div class="text-right">
          <b-btn variant="primary" @click="closeNewGiModal">{{$t('general.ok')}}</b-btn>
        </div>
      </div>
    </FITModal>
    <FITModal ref="deletePolicyModal" reference="deletePolicy" :title="$t('osm.contents.general.delete')" @click="onClickModalDelete">
      <div slot="body">
        <div class="my-4">
          <h5 v-html="$t('osm.contents.general.deletePolicyConfirm',{policyNumber: giGeneralInfo.policyNumber, policyRef: giGeneralInfo.policyReference})"></h5>
        </div>
      </div>
    </FITModal>
    <b-modal id="cbModal" :size="selectedChangeBusinessAction === 'surrender' ? 'lg': 'md'" ref="cbModal" @ok="onClickCbModalOk" :ok-variant="isFirstTimeClickedModalOk?'primary':'success'" cancel-variant="danger" @hidden="onHideCbModal" :title="$t('osm.contents.general.changeBusiness.title') + ' - ' + $t(`osm.contents.general.changeBusiness.${this.selectedChangeBusinessAction}`)">
      <div>
        <p v-html="changeBusinessConfirmContent"></p>
      </div>
      <div class="mt-3">
        <div :class="{'w-50':selectedChangeBusinessAction === 'surrender'}">
          <FITDatePicker :label="$t(`osm.contents.general.changeBusiness.${selectedChangeBusinessAction}`) +' '+$t('general.date')" :width="8" v-model="changeBusinessEffectDate" :placeholder="$t('general.selectDate')"></FITDatePicker>
        </div>
        <FITWorkflowFileUpload v-if="selectedChangeBusinessAction === 'surrender'" ref="fitFileUpload"></FITWorkflowFileUpload>
      </div>
      <div v-if="!isFirstTimeClickedModalOk" class="my-4">
        <h5 v-html="changeBusinessWarning" style="color:red"></h5>
      </div>
      <b-alert :show="modalAlertCd" dismissible variant="danger" @dismissed="modalAlertCd=0">{{$t('general.updateError')}}</b-alert>
    </b-modal>
    <b-row align-h="center" class="mt-0 pt-0">
      <div class="w-75">
        <b-alert :show="dismissCountDown" dismissible :variant="submitSuccess?'success':'danger'" @dismissed="dismissCountDown=0">{{$t('general.updateSuccess')}}</b-alert>
        <b-row align-h="between" align-v="center" class="mb-3">
          <b-col align-self="start">
            <FITButton class="mr-3" v-if="!prevBtnStatus.hide " @click="submitForm(true)" variant="primary" :text="$t('general.workflow.previous')" size="md"></FITButton>
            <FITButton v-if="!deleteBtnStatus.hide " @click="onClickDeletePolicy" variant="warning" :text="$t('osm.contents.general.delete')" size="md"></FITButton>
          </b-col>
          <b-col align-self="end" class="text-right">
            <FITButton class="mr-3" v-if="!saveBtnStatus.hide" @click="onClickSave" :text="$t('general.CURD.update')" size="md"></FITButton>
            <!-- <FITDropdown class="mr-3" v-if="workflowCurrentIndex > 5" v-model="changeBusinessActions.value.action" variant="primary" :text="changeBusinessActions.label" :options="changeBusinessActions.options" @clicked="onClickChangeBusiness"></FITDropdown> -->
            <FITButton v-if="!nextBtnStatus.hide && !isPolicyCompleted" @click="submitForm(false)" variant="primary" :text="nextBtnText" size="md"></FITButton>
            <template v-else>
              <FITButton v-if="!rejectBtnStatus.hide && !isPolicyRejected" class="mr-3" @click="submitForm(false, 0)" size="md" variant="danger" :text="$t('osm.contents.giPolicy.workflowReject')"></FITButton>
              <FITButton v-if="!inforceBtnStatus.hide " @click="submitForm(false, 1)" size="md" variant="success" :text="$t('osm.contents.giPolicy.workflowInforce')"></FITButton>
            </template>
            <!-- <div v-if="isPolicyCompleted" class="text-right">
              <h3><b-badge variant="success">{{$t('osm.contents.general.completedPolicy')}}</b-badge>
              </h3>
            </div> -->
            <div v-if="isPolicyRejected" class="text-right">
              <h3><b-badge variant="danger">{{$t('osm.contents.general.rejectedPolicy')}}</b-badge>
              </h3>
            </div>
          </b-col>
        </b-row>
        <!-- hard coded props for OutRequirement -->
        <FITOutstandingRequirement v-if="!orSectionStatus.hide" policyType="G" :policyID="this.policyID"></FITOutstandingRequirement>
        <NewGIPolicyGeneralInfo ref="giGeneralInfoComponent" @input="onChangeGeneralInfo"></NewGIPolicyGeneralInfo>
        <NewGIPolicyPolicyInfo ref="giPolicyInfoComponent" v-model="form.giTypeInfo"></NewGIPolicyPolicyInfo>
        <b-row>
          <b-col align-self="start">
            <FITButton class="mr-3" v-if="!prevBtnStatus.hide" @click="submitForm(true)" variant="primary" :text="$t('general.workflow.previous')" size="md"></FITButton>
            <FITButton v-if="!deleteBtnStatus.hide " @click="onClickDeletePolicy" variant="warning" :text="$t('osm.contents.general.delete')" size="md"></FITButton>
          </b-col>
          <b-col align-self="end" class="text-right">
            <FITButton v-if="!saveBtnStatus.hide" class="mr-3" @click="onClickSave" :text="$t('general.CURD.update')" size="md"></FITButton>
            <FITButton v-if="!nextBtnStatus.hide && !isPolicyCompleted" @click="submitForm(false)" variant="primary" :text="nextBtnText" size="md"></FITButton>
            <template v-else>
              <FITButton v-if="!rejectBtnStatus.hide && !isPolicyRejected" class="mr-3" @click="submitForm(false, 0)" size="md" variant="danger" :text="$t('osm.contents.giPolicy.workflowReject')"></FITButton>
              <FITButton v-if="!inforceBtnStatus.hide" @click="submitForm(false, 1)" size="md" variant="success" :text="$t('osm.contents.giPolicy.workflowInforce')"></FITButton>
            </template>
          </b-col>
        </b-row>
      </div>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import { NewGIPolicyGeneralInfo, NewGIPolicyPolicyInfo } from '../components'
import { FITWorkflowProgressbar, FITButton, FITModal, FITOutstandingRequirement, FITDropdown, FITDatePicker, FITWorkflowFileUpload,FITValidationBus } from '@/components'
import Vue from 'vue';
import { mapState } from 'vuex'
import workflowStepRequirement from '../assets/_workflowStepRequirement'
import { FormWizard, TabContent, WizardButton, WizardStep } from 'vue-form-wizard'
import Cookies from 'js-cookie'
 
export default {
  name: "NewGIPolicyContainer",
  props: {
    renewalPolicyID: String,
  },
  components: {
    FITDropdown,
    FITButton,
    FITWorkflowProgressbar,
    NewGIPolicyGeneralInfo,
    NewGIPolicyPolicyInfo,
    FITModal,
    FITOutstandingRequirement,
    FITDatePicker,
    FITWorkflowFileUpload,
  },
  computed: {
     permissionLevel(){
      return this.$store.state.permissionLevel;
    },
    nextBtnText() {
      if (this.workflowCurrentIndex == 8) {
        return this.$t('general.workflow.finish');
      }
      return this.$t('general.workflow.next');
    },
    changeBusinessConfirmContent() {
      return this.$t('osm.contents.general.changeBusiness.confirmActionContent', {
        policyOwner: this.ownerCustomer.english + ' ' + this.ownerCustomer.chinese,
        policyNumber: this.giGeneralInfo.policyNumber
      })
    },
    currentStepRequirements() {
      return workflowStepRequirement.requirements['step' + (this.workflowCurrentIndex + 1)]
    },
    ...mapState({
      'vuexFinalResult': state => state.Validation.validationFinalResult,
      ownerCustomer: state => state.GIPolicy.newGI.ownerCustomer,
      insuredCustomer: state => state.GIPolicy.newGI.insuredCustomer,
      currentAgent: state => state.GIPolicy.newGI.currentAgent,
      OriginalAgent: state => state.GIPolicy.newGI.OriginalAgent,
      productName: state => state.GIPolicy.newGI.productName,
      workflowCurrentIndex: state => state.GIPolicy.newGI.workflowCurrentStep,
      policyID: state => state.GIPolicy.newGI.policyID,
      paymentMethodID: state => state.GIPolicy.newGI.paymentMethodID,
      giTypeID: state => state.GIPolicy.newGI.giTypeID,
      prevBtnStatus: state => state.GIPolicy.newGI.fields.prevBtn,
      nextBtnStatus: state => state.GIPolicy.newGI.fields.nextBtn,
      deleteBtnStatus: state => state.GIPolicy.newGI.fields.deleteBtn,
      inforceBtnStatus: state => state.GIPolicy.newGI.fields.inforceBtn,
      isPolicyRejected: state => state.GIPolicy.newGI.isRejected,
      isPolicyCompleted: state => state.GIPolicy.newGI.isCompleted,
      orSectionStatus: state => state.GIPolicy.newGI.fields.orSection,
      rejectBtnStatus: state => state.GIPolicy.newGI.fields.rejectBtn,
      saveBtnStatus: state => state.GIPolicy.newGI.fields.saveBtn,
      giGeneralInfo: state => state.GIPolicy.newGI.giGeneralInfo,
      giPaymentMethod: state => state.GIPolicy.newGI.giPaymentMethod,
      giTypeInfo: state => state.GIPolicy.newGI.giTypeInfo,
    }),
    changeBusinessWarning() {
      return this.$t('osm.contents.general.changeBusiness.confirmActionWarning', {
        action: this.$t(`osm.contents.general.changeBusiness.${this.selectedChangeBusinessAction}`),
      })
    },
  },
  watch: {
    workflowCurrentIndex(newData,oldData) {
      this.transitToCurrentStep();
      this.getValidationRule(newData);
    },
    vuexFinalResult(newData,oldData){
       let result = newData;
       // console.log("Final Result: "+newData);
      if(result){
        this.submitAction( this.submit.isToPrev, this.submit.policyActionType );
        this.$store.commit('Validation/validationReset');
        // FITValidationBus.$emit('reset', true);
      }
    }
  },
  data() {
    return {
      modalAlertCd: 0,
      dismissSecs: 3,
      dismissCountDown: 0,
      submitSuccess: false,
      newFileUploaded: {},
      changeBusinessEffectDate: '',
      isFirstTimeClickedModalOk: true,
      selectedChangeBusinessAction: '',
      notificationContent: this.$t('osm.contents.general.completedPolicy'),
      workflowPrevIndex: 0,
      form: {
        giGeneralInfo: {},
        giTypeInfo: {},
        giPaymentMethod: {},
        attachment: {},
        files: {}
      },
      workflow: [
        { name: this.$t('osm.contents.giPolicy.workflowCreate') },
        { name: this.$t('osm.contents.giPolicy.workflowConfirm') },
        { name: this.$t('osm.contents.giPolicy.workflowSentOut') },
        { name: this.$t('osm.contents.giPolicy.workflowUnderwriting') },
        { name: this.$t('osm.contents.giPolicy.workflowReject') },
        { name: this.$t('osm.contents.giPolicy.workflowInforce') },
        { name: this.$t('osm.contents.giPolicy.workflowCompanyReceive') },
        { name: this.$t('osm.contents.giPolicy.workflowAgentReceive') },
        { name: this.$t('osm.contents.giPolicy.workflowCustomerReceive') }
      ],
      changeBusinessActions: {
        value: { rowID: '', action: '' },
        key: 'actions',
        label: this.$t('osm.contents.general.changeBusiness.title'),
        options: [
          { text: this.$t('osm.contents.general.changeBusiness.lapse'), key: 'lapse' },
          { text: this.$t('osm.contents.general.changeBusiness.surrender'), key: 'surrender' },
          { text: this.$t('osm.contents.general.changeBusiness.reinstate'), key: 'reinstate' }
        ]
      },
        submit:{
        isToPrev:false,
        policyActionType:1,
      }
    }
  },
  created() {
    console.log(this.renewalPolicyID);
    console.debug(this.workflowCurrentIndex);
    console.log(this.policyID);

    if (this.renewalPolicyID) {
      this.$store.dispatch('GIPolicy/getGIDetail').then((json) => {
        Vue.set(this, 'workflowPrevIndex', 0);
        this.$store.commit('GIPolicy/resetGIPolicyIDs');

      }).catch((error) => {
        console.log(error);
      })
      return;
    }
    if (this.workflowCurrentIndex > 0) {
      this.$store.dispatch('GIPolicy/getGIDetail').then((json) => {

        Vue.set(this, 'workflowPrevIndex', this.workflowCurrentIndex);
        // this.$store.dispatch('GIPolicy/setAllGiInfo', json);
      }).catch((error) => {
        console.log(error);
      })
    }
    
      this.getValidationRule(this.workflowCurrentIndex);
      this.permissionCheck();

  },
  methods: {
   permissionCheck(){
      let permissionLevel = this.permissionLevel;
      console.log(permissionLevel);
      if(permissionLevel>3.5){
          this.$store.commit('GIPolicy/disabledButtonStatus');
      }
    },
    getValidationRule(index){
      FITValidationBus.$emit('reset',true);
      this.$store.commit('Validation/validationReset');
      this.$store.commit('Validation/setAlertMsg',{alertMsg: this.$t("validation.alertMsg.error")});
      let action;
        switch(index){
          case 0:
          action = 'create';
          break;
          case 1:
          action = 'confirm';
          break;
          case 2:
          action = 'sendOut';
          break;
          case 5:
          action = 'inforce';
          break;
          case 6:
          action = 'companyReceive';
          break;
          case 7:
          action = 'agentReceive';
          break;
          case 8:
          action = 'customerReceive';
          break;
          default:
          action = 'create';
          break;
        }

      this.$store.dispatch('Validation/getValidationRule',`/osm/generalPolicy/${action}`);

    },
   submitForm(isToPrev, policyActionType){
      if(isToPrev){
      this.submitAction(isToPrev, policyActionType);
      }else{
      this.$store.dispatch('Validation/validationCheckBeforeSubmit');
      this.submit.isToPrev = isToPrev;
      this.submit.policyActionType = policyActionType;
      }
    },


    onClickModalDelete(event) {
      if (!event) {
        return;
      }
      this.$store.dispatch('GIPolicy/deleteGIPolicy', this.policyID).then((json) => {
        this.$refs.deletePolicyModal.closeModal();
        this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', 0);
        this.$router.replace({ name: 'GI Policy List', params: { alertContent: this.$t('osm.contents.general.deleteSuccess'), alertVariant: 'success' } });
      })
    },
    onClickDeletePolicy() {
      this.$refs.deletePolicyModal.openModal();
    },
    searchOption(obj, success) {
      var payload = {
        ...obj,
        ...{ dest: "option" },
      }
      this.$store.dispatch('searchOption', payload)
        .then((json) => {
          success(json);
        })
        .catch((err) => {
          console.debug(err);
        });
    },
    searchAgentOrCustomer(optionType, id, dataKey) {
      var payload = { optionType: optionType, searchInput: { ID: id } }
      this.searchOption(payload, (json) => {
        if (json.length == 0) {
          Vue.set(this[dataKey], 'english', 'N/A');
        } else {
          Vue.set(this[dataKey], 'english', json[0].englishFullname);
          Vue.set(this[dataKey], 'chinese', json[0].chineseFullname);
        }
      });
    },
    onClickSave() {
      this.$store.dispatch('GIPolicy/saveGIPolicy', this.form).then(() => {
        // Vue.set(this.form.giGeneralInfo, 'version', (this.form.giGeneralInfo.version + 1));
        // Vue.set(this.form.giTypeInfo, 'version', (this.form.giTypeInfo.version + 1));
        // Vue.set(this.form.giPaymentMethod, 'version', (this.form.giPaymentMethod.version + 1));
      })
    },
    submitAction(isToPrev, policyActionType) {
      var apiIndex = this.workflowCurrentIndex;
      if (isToPrev && apiIndex != 4 && apiIndex != 5) {
        this.$store.commit({ type: 'GIPolicy/setIsRejected', value: false })
        this.$store.commit({ type: 'GIPolicy/setIsCompleted', value: false })
        apiIndex -= 1;
      }
      var uploadedfileData = this.$refs.giGeneralInfoComponent.uploadFile();
      this.$refs.giPolicyInfoComponent.saveToVuex();
      this.$refs.giGeneralInfoComponent.saveToVuex();

      this.onUploadedFile(uploadedfileData);
      // this.form['attachment'] = uploadedfileData.attachment;
      this.setFormFromVuex();

      switch (apiIndex) {
        case 0:
          this.$store.dispatch('GIPolicy/createGIPolicy', this.form, isToPrev).then((json) => {
            // Vue.set(this.form, 'attachment', {});
            // Vue.set(this.form, 'files', {});
            this.$refs.giGeneralInfoComponent.resetFileUpload();
          }).catch((err) => {
            console.log(this.form)
            console.log(err);
          });

          console.log(this.form);
          break;
        case 1:
          this.$store.dispatch('GIPolicy/confirmGIPolicy', { form: this.form, isToPrev: isToPrev }).then(() => {
            // Vue.set(this.form, 'attachment', {});
            // Vue.set(this.form, 'files', {});
            this.$refs.giGeneralInfoComponent.resetFileUpload();
          })
          break;
        case 2:
          this.$store.dispatch('GIPolicy/sendOutGIPolicy', { form: this.form, isToPrev: isToPrev }).then(() => {
            // Vue.set(this.form, 'attachment', {});
            // Vue.set(this.form, 'files', {});
            this.$refs.giGeneralInfoComponent.resetFileUpload();
          })
          break;
        case 3:
          switch (policyActionType) {
            case 0:
              //reject
              this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', 4)
              break;
            case 1:
              //inforce
              this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', 5)
              break;
          }
          break;
        case 4:
          if (isToPrev) {

            this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', 3);
            break;
          }
          this.$store.dispatch('GIPolicy/rejectGIPolicy', this.policyID).then(() => {
            // Vue.set(this.form, 'attachment', {});
            // Vue.set(this.form, 'files', {});
            this.$refs.giGeneralInfoComponent.resetFileUpload();
            this.openNewGiModal(0);
          })
          break;
        case 5:
          if (isToPrev) {
            // console.debug(clicked);
            this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', 3);
            break;
          }
          this.$store.dispatch('GIPolicy/inforceGIPolicy', this.form).then(() => {
            // Vue.set(this.form, 'attachment', {});
            // Vue.set(this.form, 'files', {});
            this.$refs.giGeneralInfoComponent.resetFileUpload();
          })
          break;
        case 6:
          this.$store.dispatch('GIPolicy/companyReceiveGIPolicy', { form: this.form, isToPrev: isToPrev });
          break;
        case 7:
          this.$store.dispatch('GIPolicy/agentReceiveGIPolicy', { form: this.form, isToPrev: isToPrev });
          break;
        case 8:
          this.$store.dispatch('GIPolicy/customerReceiveGIPolicy', { form: this.form, isToPrev: isToPrev }).then(() => {
            this.openNewGiModal(1);
          });
          break;
      }

      window.scrollTo(0,0);
    },
    setCurrentStepFieldStatus() {
      this.currentStepRequirements.forEach((item) => {
        console.debug(item);
        this.$store.commit({
          type: 'GIPolicy/setCurrentStepFieldStatus',
          name: item.name,
          disabled: item.status.disabled,
          hide: item.status.hide
        });
      })
    },
    transitToCurrentStep() {
      if (this.workflowCurrentIndex > this.workflowPrevIndex) {
        var times = this.workflowCurrentIndex - this.workflowPrevIndex;
        for (var i = 0; i < times; i++) {
          this.$refs.GIWorkflowProgress.nextTab();
        }
      } else {
        var times = this.workflowPrevIndex - this.workflowCurrentIndex;
        for (var i = 0; i < times; i++) {
          this.$refs.GIWorkflowProgress.prevTab();
        }
      }
      Vue.set(this, 'workflowPrevIndex', this.workflowCurrentIndex);
    },
    onChangeGeneralInfo(giGeneralInfo, giPaymentMethod) {
      Vue.set(this.form, 'giGeneralInfo', giGeneralInfo);
      Vue.set(this.form, 'giPaymentMethod', giPaymentMethod);
    },
    onUploadedFile(files) {
      // console.log(files)
      Vue.set(this.form, 'attachment', files.attachment);
      Vue.set(this.form, 'files', files.files);
      // console.log(this.form);
    },
    openNewGiModal(val) {
      switch (val) {
        case 0:
          // rejected
          Vue.set(this, 'notificationContent', this.$t('osm.contents.general.rejectedPolicyModal', { type: this.$t('osm.contents.general.gi') }));
          break;
        case 1:
          //completed
          Vue.set(this, 'notificationContent', this.$t('osm.contents.general.completedPolicyModal', { type: this.$t('osm.contents.general.gi') }))
          break;
      }
      this.$refs.newGiModal.openModal();
    },
    closeNewGiModal() {
      this.$refs.newGiModal.closeModal();
      this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', 0);
      this.$router.replace('/osm/gi/list')
    },
    setFormFromVuex() {
      Vue.set(this.form, 'giGeneralInfo', JSON.parse(JSON.stringify(this.giGeneralInfo)));
      Vue.set(this.form, 'giPaymentMethod', JSON.parse(JSON.stringify(this.giPaymentMethod)));
      Vue.set(this.form, 'giTypeInfo', JSON.parse(JSON.stringify(this.giTypeInfo)));
      if (this.policyID != -1) {
        Vue.set(this.form.giGeneralInfo, 'ID', this.policyID);
      }
      if (this.paymentMethodID != -1) {
        Vue.set(this.form.giPaymentMethod, 'ID', this.paymentMethodID);
      }
      if (this.giTypeID != -1) {
        Vue.set(this.form.giTypeInfo, 'ID', this.giTypeID);
      }
    },
    uploadFile() {
      var fileData = this.$refs.fitFileUpload.formUploadFiles();
      console.debug(fileData);
      Vue.set(this, 'newFileUploaded', fileData);
      return fileData;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    showModalAlert() {
      this.modalAlertCd = this.dismissSecs;
    },
    onHideCbModal() {
      Vue.set(this, 'isFirstTimeClickedModalOk', true);
      Vue.set(this, 'changeBusinessEffectDate', '');
      Vue.set(this, 'newFileUploaded', {});
    },
    onClickCbModalOk(evt) {
      evt.preventDefault();
      if (this.isFirstTimeClickedModalOk) {
        Vue.set(this, 'isFirstTimeClickedModalOk', false);
        Vue.set(this, 'submitSuccess', true);
        return;
      }

      switch (this.selectedChangeBusinessAction) {
        case 'lapse':
          var params = { ID: this.giGeneralInfo.ID, policyLapseDate: this.changeBusinessEffectDate }
          this.$store.dispatch('GIPolicy/lapseGI', params).then(() => {
            this.$store.dispatch('GIPolicy/getGIDetail');
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();
          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })

          break;
        case 'surrender':
          var fileData = this.uploadFile();
          var params = { ID: this.giGeneralInfo.ID, policyEndDate: this.changeBusinessEffectDate, files: fileData.files, attachment: fileData.attachment }
          this.$store.dispatch('GIPolicy/surrenderGI', params).then(() => {
            this.$store.dispatch('GIPolicy/getGIDetail');
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();

          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })
          break;
        case 'reinstate':
          var params = { ID: this.giGeneralInfo.ID, policyReinstateDate: this.changeBusinessEffectDate }
          this.$store.dispatch('GIPolicy/reinstateGI', params).then(() => {
            this.$store.dispatch('GIPolicy/getGIDetail');
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();
          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })
          break;
      }

    },
    onClickChangeBusiness(actionType) {
      Vue.set(this, 'selectedChangeBusinessAction', actionType)
      this.$refs.cbModal.show()
    },
  },
  destroyed() {
    this.$store.dispatch('GIPolicy/resetNewGIState');
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/GIPolicy/containers/NewGIPolicyContainer.vue